import React from 'react';
import { useTranslation } from 'react-i18next';

import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import InputAdornment from '@material-ui/core/InputAdornment';

import InputText from '~/components/Input/InputText';
import IconButton from '~/components/Button/IconButton';

const InputSearch = ({ value, onChange, label, placeholder, style }) => {
  const { t } = useTranslation();

  return (
    <InputText
      style={style}
      value={value}
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value && (
              <IconButton
                tooltip={t('action.erase')}
                Icon={CloseIcon}
                onClick={() => onChange('')}
                iconColor="red"
              />
            )}
            <IconButton
              tooltip={t('action.search')}
              Icon={SearchIcon}
              iconColor="secondary"
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default InputSearch;
